/**
 * Error state: unauthorized / auth failure.
 */
import React from "react";
import ErrorDisplay from "../../../components/common/ErrorDisplay";

export default function LoginErrorView({ messageBoxInfo, onRetry, userDataLoadStatus }) {
  return (
    <ErrorDisplay
      messageBoxInfo={messageBoxInfo}
      onRetry={onRetry}
      userDataLoadStatus={userDataLoadStatus}
    />
  );
}
